import axiosInstance from '../RestClient';

const BASE_URI = '/documents';
class DocumentService {
	async list() {
		const uri = `${BASE_URI}/`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async getDetails(recordId) {
		const uri = `${BASE_URI}/${recordId}`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async getByType(documentType) {
		const uri = `${BASE_URI}/type/${documentType}`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async create(payload, relatedObjectId, relatedObjectType) {
		const response = await axiosInstance.post(`${BASE_URI}/`, {
			...payload,
			relatedObjectId,
			relatedObjectType,
		});
		return response;
	}

	async edit(recordId, payload) {
		const response = await axiosInstance.put(`${BASE_URI}/${recordId}`, payload);
		return response;
	}

	async delete(recordId, relatedObjectId, relatedObjectType) {
		const uri = `${BASE_URI}/${recordId}`;
		const response = await axiosInstance.delete(uri, {
			data: { relatedObjectId, relatedObjectType },
		});
		return response;
	}

	async upload(formData, documentType) {
		formData.append('documentType', documentType);
		const uploadUri = '/documents/upload';
		// Content-Type must be left unset so axios/the browser can compute the
		// multipart boundary; the instance default is 'application/json', so it
		// has to be explicitly cleared per-request (undefined removes a header
		// in axios's config merge — a plain object here is silently ignored).
		const response = await axiosInstance.post(uploadUri, formData, { headers: { 'Content-Type': undefined } });
		return response;
	}

	async uploadFile(formData, documentType) {
		// Determine the upload endpoint based on document type
		let uploadUri = '';
		switch (documentType) {
		case 'escritura':
			uploadUri = '/assets/uploadEscritura';
			break;
		case 'comprobante':
			// For comprobante, we'll need a generic upload endpoint or use bills
			uploadUri = '/bills/uploadComprobante';
			break;
		case 'document':
			uploadUri = '/assetSales/uploadDocument';
			break;
		default:
			uploadUri = '/bills/uploadComprobante';
		}
		const response = await axiosInstance.post(uploadUri, formData, { headers: { 'Content-Type': undefined } });
		return response;
	}
}
export default new DocumentService();

